export default __webpack_public_path__ + "static/media/user-check.0fb17fad.svg";